import React from 'react';
import { Field, reduxForm } from 'redux-form';
import {
  FormGroup,
  InputGroup,
  Button,
  ButtonToolbar,
  ControlLabel,
  FormControl,
} from 'react-bootstrap';

export const renderBootstrapField = ({ input, label, type, meta: { touched, error, warning } }) => (
  <InputGroup>
    { label && (<ControlLabel>{label}</ControlLabel>)}
    <FormControl
      {...input}
      type={type}
    />
    {touched &&
      ((error && <span>{error}</span>) ||
        (warning && <span>{warning}</span>))}
  </InputGroup>
);

export const SpecialOfferInput = ({ input, label, type, help, meta: { touched, error, warning } }) => (
  <FormGroup>
  { label && (<ControlLabel>{label}</ControlLabel>)}
    <FormControl
      {...input}
      componentClass="textarea"
      name="special_offer"
      placeholder="Please provide detail about special offer."
    />
    {help && <HelpBlock>{help}</HelpBlock>}
  </FormGroup>
);

const HotelSpecialOfferForm = (props) => {
  const { handleSubmit, pristine, reset, submitting, handleClose, initialValues } = props;
  return (
    <div>
    <h4 className="hotel-highlight">Special Offer</h4>
      <form onSubmit={handleSubmit} initialValues={initialValues}>
        <FormGroup>
           <Field
              name="special_offer"
              type="textarea"
              component={SpecialOfferInput}
            />
        </FormGroup>
        <FormGroup>
          <ButtonToolbar>
            <Button bsStyle="success" onClick={handleSubmit} disabled={pristine || submitting}>
              Save
            </Button>
            <Button bsStyle="success" onClick={handleClose}>
              Discard Changes
            </Button>
          </ButtonToolbar>
        </FormGroup>
      </form>
    </div>
  );
};

export default reduxForm({
  form: 'HotelSpecialOfferForm', // a unique identifier for this form
})(HotelSpecialOfferForm);



// WEBPACK FOOTER //
// src/routes/hotels/components/HotelSpecialOfferForm.js